import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    subject: '',
    domain: '',
    is_peer_assessment_only: ''
  },
}

export const rubricsUI = createSlice({
  name: 'rubricsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setDomain: (state, { payload }) => {
      state.tableFilters.domain = payload
    },
    setIsPeerAssessmentOnly: (state, { payload }) => {
      state.tableFilters.is_peer_assessment_only = payload
    },
    trackActiveFilters: (state) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setSubject,
  setDomain,
  setIsPeerAssessmentOnly,
  trackActiveFilters,
  clearAllFilters,
} = rubricsUI.actions

export default rubricsUI.reducer
